/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Quick_Workout_Notice_Readiness_CutInputs */

const en_us2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% fewer sets for today's sleep or stress.`)
};

const pt_br2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.pct}% de séries pelo sono ou pelo estresse de hoje.`)
};

const es_419_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos series por el sueño o el estrés de hoy.`)
};

const pt_pt2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.pct}% de séries pelo sono ou pelo stress de hoje.`)
};

const fr_fr2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % de séries en moins à cause du sommeil ou du stress du jour.`)
};

const de_de2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% weniger Sätze wegen Schlaf oder Stress heute.`)
};

const it_it2_quick_workout_notice_readiness_cut = /** @type {(inputs: Quick_Workout_Notice_Readiness_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% di serie in meno per il sonno o lo stress di oggi.`)
};

/**
* | output |
* | --- |
* | "{pct}% fewer sets for today's sleep or stress." |
*
* @param {Quick_Workout_Notice_Readiness_CutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_notice_readiness_cut = /** @type {((inputs: Quick_Workout_Notice_Readiness_CutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Notice_Readiness_CutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_notice_readiness_cut(inputs)
	if (locale === "es-419") return es_419_quick_workout_notice_readiness_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_notice_readiness_cut(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_notice_readiness_cut(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_notice_readiness_cut(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_notice_readiness_cut(inputs)
	return en_us2_quick_workout_notice_readiness_cut(inputs)
});
export { quick_workout_notice_readiness_cut as "quick-workout.notice_readiness_cut" }